import utils from '@/utils';
import { isFunction, isObject, isArray, each } from 'lodash';

export default {
  /**
   * Parses location object with fields lat and lng from string containing them
   * divided by comma
   * @param  {String} str LatLng string, for example 43.1231,-32.1214
   * @return {Location}     LatLng object
   */
  parseLocation: function (str) {
    if (!str) return;
    const checkRE = /^[-0-9.]+,[-0-9.]+$/;
    if (!checkRE.test(str)) return;
    var latlngStr = str.split(',', 2);
    var latlng = new Location(parseFloat(latlngStr[0]),
      parseFloat(latlngStr[1]));
    return latlng;
  },

  /**
   * Checks if given object is a valid LatLng object
   * @param  {Object}  latlng LatLng object
   * @return {Boolean}        True if valid
   */
  isValidLatLng: function (latlng) {
    if (!isObject(latlng)) return false;
    let lat = isFunction(latlng.lat) ? latlng.lat() : latlng.lat;
    let lng = isFunction(latlng.lng) ? latlng.lng() : latlng.lng;
    return utils.number.isFloat(lat) && utils.number.isFloat(lng);
  },

  /**
   * Stringifies location object in the form of [lat,lng]
   * @param  {Object} latlng Location object with lat and lng
   * @return {String}        Stringified
   */
  stringifyLocationLatLng(latlng) {
    if (!isObject(latlng)) return;
    let lat = isFunction(latlng.lat) ? latlng.lat() : latlng.lat;
    let lng = isFunction(latlng.lng) ? latlng.lng() : latlng.lng;
    return lat + ',' + lng;
  },

  /**
   * Finds closest location
   * @param  {Object} location Location geometry, e.g. containing lat and lng
   * @param  {Array}  list     List of places got from google API
   * @return {Object}          Closest place to given location geometry
   */
  findClosest(location, list) {
    if (!isObject(location) || !isArray(list)) return;
    let lat = isFunction(location.lat) ? location.lat() : location.lat;
    let lng = isFunction(location.lng) ? location.lng() : location.lng;
    let result = null;
    let minDist = null;
    each(list, (v, i) => {
      let latV = isFunction(v.geometry.location.lat) ?
        v.geometry.location.lat() : v.geometry.location.lat;
      let lngV = isFunction(v.geometry.location.lng) ?
        v.geometry.location.lng() : v.geometry.location.lng;
      let dy = Math.abs(Math.abs(lat) - Math.abs(latV));
      let dx = Math.abs(Math.abs(lng) - Math.abs(lngV));
      let dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < minDist || i === 0) {
        minDist = dist;
        result = v;
      }
    });
    return result;
  },

  /**
   * Creates new instance of Location class using coordinates got from geocode
   * @param  {Object} l Geocoded object
   * @return {Location}   Location object (instance of class Location below)
   */
  transformGeocoded(l) {
    let result = null;
    if (l && l.geometry && l.geometry.location) {
      let lat = isFunction(l.geometry.location.lat) ?
        l.geometry.location.lat() : l.geometry.location.lat;
      let lng = isFunction(l.geometry.location.lng) ?
        l.geometry.location.lng() : l.geometry.location.lng;
      result = new Location(lat, lng, l.place_id, l.formatted_address);
    }
    return result;
  }
}

export class Location {

  constructor(lat, lng, placeId, address) {
    this.lat = lat;
    this.lng = lng;
    this.placeId = placeId;
    this.address = address;
  }

}
